import { FC } from "react";
import { IconProps } from "./types";

export const Arrow: FC<IconProps> = ({ className, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.747"
    height="7.814"
    viewBox="0 0 15.747 7.814"
    className={className}
    {...props}
  >
    <path d="M11.265 7.728a.729.729 0 0 1-.443-.649v-2.46H.738A.733.733 0 0 1 0 3.909a.757.757 0 0 1 .738-.738h10.085V.738a.739.739 0 0 1 1.241-.541l3.448 3.2a.738.738 0 0 1 0 1.082l-3.448 3.2a.784.784 0 0 1-.799.049Z" />
  </svg>
);
